import Extension from 'owa-service/lib/contract/Extension';
import { AddinFactory, IAddin } from 'owa-addins-store';
import { ExtensibilityModeEnum } from 'owa-addins-types';

export default class AddinActivator {
    constructor(private addinFactory: AddinFactory) {}

    activate(activeExtensions: Extension[], mode: ExtensibilityModeEnum): Promise<IAddin[]> {
        return new Promise<IAddin[]>((resolve, reject) => {
            const addins: IAddin[] = [];
            activeExtensions.forEach((extension: Extension) => {
                const addin: IAddin = this.addinFactory.CreateAddinIfEntryPointSupported(
                    extension,
                    mode
                );

                if (addin) {
                    addins.push(addin);
                }
            });

            resolve(addins);
        });
    }
}
